import React from 'react';
import { Link, useLocation } from "react-router-dom";
import "./breadcrumb.css"

const Breadcrumbs = (props) => {
    const location = useLocation();

    // Get the path segments from the current location

    return <React.Fragment>
        <div className='d-flex justify-content-between pb-0'>
            <div>
                <div className='dash-label'>{props.title}</div>
                <div className='d-flex mt-1'>
                    <div className='breadcrum my-auto' >Dashboard</div>
                    <div className='mx-1'>{props.menu?<span>&raquo;</span>:""}</div>
                    <div className='breadcrum  my-auto'>{props.menu}</div>
                    <div className='mx-1 '>{props.link?<span>&raquo;</span>:""}</div>
                    <div className='breadcrumlink  my-auto'>{props.link}</div>
                </div>
            </div>
            <div className='my-auto'>
                <button className='btn btn-primary shadow-sm' onClick={()=>{
                    window.history.back()
                }}>Back</button>
            </div>
        </div><hr/>
    </React.Fragment>
};

export default Breadcrumbs;


